import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import Button from '../../components/atoms/Button';
import { TRANSLATION_KEY, WEEK_DAY_NUMBERS } from '../constants';
import { formatWeekDayLabel } from '../utils';
import css from './ScheduleDaysPicker.css';

const SCHEDULE_KEY = `${TRANSLATION_KEY}.SCHEDULE`;

const ScheduleDaysPicker = ({ days, onChange }) => {
    const toggleDay = day => onChange(days.includes(day) ? days.filter(d => d !== day) : [...days, day]);
    const allSelected = days.length === WEEK_DAY_NUMBERS.length;

    return (
        <div>
            <div className={css.header}>
                <span className={css.label}>
                    <Translate id={`${SCHEDULE_KEY}.DAYS`} />
                </span>
                <Button
                    type="link"
                    className={css.quickLink}
                    onClick={() => onChange(allSelected ? [] : WEEK_DAY_NUMBERS)}
                >
                    <Translate id={`${SCHEDULE_KEY}.${allSelected ? 'CLEAR_DAYS' : 'ALL_DAYS'}`} />
                </Button>
            </div>
            <div className={css.days}>
                {WEEK_DAY_NUMBERS.map(day => (
                    <Button
                        key={day}
                        type="flat"
                        className={classNames(css.day, { [css.daySelected]: days.includes(day) })}
                        onClick={() => toggleDay(day)}
                    >
                        {formatWeekDayLabel(day)}
                    </Button>
                ))}
            </div>
        </div>
    );
};

ScheduleDaysPicker.propTypes = {
    days: PropTypes.arrayOf(PropTypes.number).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ScheduleDaysPicker;
